var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"sticky-footer bg-white"},[_c('div',{staticClass:"container my-auto"},[_c('div',{staticClass:"copyright text-center my-auto"},[_c('span',[_vm._v("Copyright © "),_c('a',{attrs:{"href":"https://gobi.my"}},[_vm._v("GoBI")]),_vm._v(" 2019-2020")])])])])
}]

export { render, staticRenderFns }